export default __webpack_public_path__ + "public/assets/images/f8756d440effef273dbb676b98981bd1.png";